import { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmModal = (props) => {
  const {
    confirmModal,
    setConfirmModal,
    showModalMsg,
    isConfirm,
    confirmId,
    confirmAction,
    isRightIcon,
    isMobile
  } = props;

  return (
    <Modal
      show={confirmModal}
      onHide={() => setConfirmModal(false)}
      size="500px"
      aria-labelledby="contained-modal-title-vcenter"
      className="alert-modal"
      centered={isMobile ? false : true}
    >
      {/* <Modal.Header closeButton className="modal-header">
            <Modal.Title>Favourite Delete Alert</Modal.Title>
            </Modal.Header> */}
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="invalidemailshowfp">
        {isConfirm ? (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="22"
              viewBox="0 0 24 22"
              fill="none"
            >
              <path
                d="M23.7526 18.5469L13.7682 1.48438C13.3463 0.828125 12.69 0.5 12.0338 0.5C11.3307 0.5 10.6744 0.828125 10.2526 1.48438L0.221349 18.5469C-0.481776 19.8594 0.455729 21.5 2.0026 21.5H22.0182C23.5651 21.5 24.5026 19.8594 23.7526 18.5469ZM2.47135 19.25L11.9869 2.98438L21.5494 19.25H2.47135ZM12.0338 14.8438C11.19 14.8438 10.5338 15.5 10.5338 16.2969C10.5338 17.0938 11.19 17.75 12.0338 17.75C12.8307 17.75 13.4869 17.0938 13.4869 16.2969C13.4869 15.5 12.8307 14.8438 12.0338 14.8438ZM10.9088 7.625V12.125C10.9088 12.7812 11.3776 13.25 12.0338 13.25C12.6432 13.25 13.1588 12.7812 13.1588 12.125V7.625C13.1588 7.01562 12.6432 6.5 12.0338 6.5C11.3776 6.5 10.9088 7.01562 10.9088 7.625Z"
                fill="#2d2d2d"
              />
            </svg>
          </>
        ) : isRightIcon ? (
          <>
            <svg
              className="apper"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="32"
              height="32"
              fill="rgba(36,209,92,1)"
            >
              <path d="M10.007 2.10377C8.60544 1.65006 7.08181 2.28116 6.41156 3.59306L5.60578 5.17023C5.51004 5.35763 5.35763 5.51004 5.17023 5.60578L3.59306 6.41156C2.28116 7.08181 1.65006 8.60544 2.10377 10.007L2.64923 11.692C2.71404 11.8922 2.71404 12.1078 2.64923 12.308L2.10377 13.993C1.65006 15.3946 2.28116 16.9182 3.59306 17.5885L5.17023 18.3942C5.35763 18.49 5.51004 18.6424 5.60578 18.8298L6.41156 20.407C7.08181 21.7189 8.60544 22.35 10.007 21.8963L11.692 21.3508C11.8922 21.286 12.1078 21.286 12.308 21.3508L13.993 21.8963C15.3946 22.35 16.9182 21.7189 17.5885 20.407L18.3942 18.8298C18.49 18.6424 18.6424 18.49 18.8298 18.3942L20.407 17.5885C21.7189 16.9182 22.35 15.3946 21.8963 13.993L21.3508 12.308C21.286 12.1078 21.286 11.8922 21.3508 11.692L21.8963 10.007C22.35 8.60544 21.7189 7.08181 20.407 6.41156L18.8298 5.60578C18.6424 5.51004 18.49 5.35763 18.3942 5.17023L17.5885 3.59306C16.9182 2.28116 15.3946 1.65006 13.993 2.10377L12.308 2.64923C12.1078 2.71403 11.8922 2.71404 11.692 2.64923L10.007 2.10377ZM6.75977 11.7573L8.17399 10.343L11.0024 13.1715L16.6593 7.51465L18.0735 8.92886L11.0024 15.9999L6.75977 11.7573Z"></path>
            </svg>
          </>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="22"
              viewBox="0 0 24 22"
              fill="none"
            >
              <path
                d="M23.7526 18.5469L13.7682 1.48438C13.3463 0.828125 12.69 0.5 12.0338 0.5C11.3307 0.5 10.6744 0.828125 10.2526 1.48438L0.221349 18.5469C-0.481776 19.8594 0.455729 21.5 2.0026 21.5H22.0182C23.5651 21.5 24.5026 19.8594 23.7526 18.5469ZM2.47135 19.25L11.9869 2.98438L21.5494 19.25H2.47135ZM12.0338 14.8438C11.19 14.8438 10.5338 15.5 10.5338 16.2969C10.5338 17.0938 11.19 17.75 12.0338 17.75C12.8307 17.75 13.4869 17.0938 13.4869 16.2969C13.4869 15.5 12.8307 14.8438 12.0338 14.8438ZM10.9088 7.625V12.125C10.9088 12.7812 11.3776 13.25 12.0338 13.25C12.6432 13.25 13.1588 12.7812 13.1588 12.125V7.625C13.1588 7.01562 12.6432 6.5 12.0338 6.5C11.3776 6.5 10.9088 7.01562 10.9088 7.625Z"
                fill="#2d2d2d"
              />
            </svg>
          </>
        )}
        {showModalMsg}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        {isConfirm ? (
          <>
            <Button
              autofocus
              variant="primary"
              className="confirm"
              onClick={() => {
                confirmAction(confirmId);
                setConfirmModal(false);
              }}
            >
              Yes
            </Button>
            <Button
              variant="secondary"
              className="confirm"
              onClick={() => setConfirmModal(false)}
            >
              No
            </Button>
          </>
        ) : (
          <Button
            variant="primary"
            className="confirm"
            onClick={() => setConfirmModal(false)}
          >
            Ok
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
